import React from 'react'
import * as R from 'ramda'
import withConnect from './connector'

// type Props = {|
//   +checkoutRedirection: {|
//     +redirectBody: any,
//     +redirectTo: string,
//   |}
// |}

class RedirectTo extends React.Component {
  componentDidUpdate () {
    if (this.formRef && this.props.checkoutRedirection.redirectTo && this.props.checkoutRedirection.redirectBody) {
      setTimeout(() => this.formRef.submit(), 300)
    }
  }

  render () {
    const { checkoutRedirection } = this.props

    return (
      <If condition={checkoutRedirection.redirectTo && checkoutRedirection.redirectBody}>
        <form
          action={checkoutRedirection.redirectTo}
          name='redirect'
          method='post'
          style={{ display: 'none' }}
          ref={ref => { this.formRef = ref }}
        >
          {R.compose(
            R.values,
            R.mapObjIndexed((value, key) =>
              <input type='text' name={key} value={value} key={key} readOnly />)
          )(checkoutRedirection.redirectBody)}
        </form>
      </If>
    )
  }
}

export default withConnect(RedirectTo)
